export default {
  setProjectsListState(state, data) {
    state.projectsList = data.length ? data : [state.projectItem];
    state.projectsErrorList = state.projectsList.map(() => state.projectErrorItem);
  },
  addEmptyProjectItem(state) {
    state.projectsList = [state.projectItem, ...state.projectsList];
    state.projectsErrorList = [state.projectErrorItem, ...state.projectsErrorList];
  },
  mutateProjectsByIndexState(state, data) {
    let list = [...state.projectsList];
    list[data.index] = {...list[data.index], ...data.changedField};
    state.projectsList = list;
  },
  deleteProjectItem(state, index) {
    state.projectsList.splice(index, 1);
    state.projectsErrorList.splice(index, 1);
  },
  mutateProjectsErrorItem(state, data) {
    let list = [...state.projectsErrorList];
    list[data.index] = {...list[data.index], ...data.changedField};
    state.projectsErrorList = list;
  }
};
